import React from "react";
import DreamModal from "./DreamModal";
import UserProfileManager from "./UserProfileManager/UserProfileManager";
import "./UserProfile.css";

const UserProfile = ({ show, onHide }) => {
  return (
    <DreamModal
      show={show}
      onHide={onHide}
      title="User Profiles"
      size="lg"
      className="profile-modal"
    >
      <UserProfileManager onClose={onHide} />
    </DreamModal>
  );
};

export default UserProfile;
